import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@ui';
import {
  CCSchedule,
  CCSchedulerSettings,
  CSSchedule,
  CSSchedulerSettings,
  SHtLuSchedule,
  SLiSchedule,
  SHtLuSchedulerSettings,
  SLiSchedulerSettings,
  OMSSchedule,
  OMSSchedulerSettings,
} from '@lp/pages/Schedule';

export const getSchedulerRoutes = (): RouteObject[] => {
  return [
    {
      path: 'schedule/cs',
      children: [
        {
          index: true,
          element: <CSSchedule />,
          errorElement: <ErrorBoundary errorMessage="Schedule loading failed." />,
        },
        {
          path: 'settings',
          element: <CSSchedulerSettings />,
          errorElement: <ErrorBoundary errorMessage="Schedule settings loading failed." />,
        },
      ],
    },
    {
      path: 'schedule/s-li',
      children: [
        {
          index: true,
          element: <SLiSchedule />,
          errorElement: <ErrorBoundary errorMessage="Schedule loading failed." />,
        },
        {
          path: 'settings',
          element: <SLiSchedulerSettings />,
          errorElement: <ErrorBoundary errorMessage="Schedule settings loading failed." />,
        },
      ],
    },
    {
      path: 'schedule/s-htlu',
      children: [
        {
          index: true,
          element: <SHtLuSchedule />,
          errorElement: <ErrorBoundary errorMessage="Schedule loading failed." />,
        },
        {
          path: 'settings',
          element: <SHtLuSchedulerSettings />,
          errorElement: <ErrorBoundary errorMessage="Schedule settings loading failed." />,
        },
      ],
    },
    {
      path: 'schedule/cc',
      children: [
        {
          index: true,
          element: <CCSchedule />,
          errorElement: <ErrorBoundary errorMessage="Schedule loading failed." />,
        },
        {
          path: 'settings',
          element: <CCSchedulerSettings />,
          errorElement: <ErrorBoundary errorMessage="Schedule settings loading failed." />,
        },
      ],
    },
    {
      path: 'schedule/oms',
      children: [
        {
          index: true,
          element: <OMSSchedule />,
          errorElement: <ErrorBoundary errorMessage="Schedule loading failed." />,
        },
        {
          path: 'settings',
          element: <OMSSchedulerSettings />,
          errorElement: <ErrorBoundary errorMessage="Schedule settings loading failed." />,
        },
      ],
    },
  ];
};
